import { IndexRoute, Route, Redirect } from 'react-router';
import React from 'react';
import App from './App';

// public applicant's page
import PreliminaryApplication from './react/f_PreliminaryApplication';

// applicant's dashboard after prelim app status
import ApplicantLanding from './react/r_ApplicantLanding';

// applicant's dashboard after prelim app status
import ApplicantDashboard from './react/r_ApplicantDashboard';

// applicant's dashboard after prelim app status
import ApplicantTerms from './react/r_ApplicantDashboard/r_ApplicantTermsAndConditions';

// applicant's resume page
import ApplicantResume from './react/r_ApplicantResume';

// guide
import ViewGuide from './react/admin/Guide/view';

// insurance company's Admin page
import AdminLanding from './react/admin';
import AdminDashboard from './react/r_AdminDashboard';
import ContactWorksheet, {OnEnterRefreshContact} from './react/admin/Contact/Worksheet';
import CompanyWorksheet, {OnEnterRefreshCompany} from './react/admin/Company/Worksheet';
import JobRequestWorksheet from './react/admin/JobRequest/Worksheet';
import JobRequestWorksheetProfile from './react/admin/JobRequest/Worksheet/Profile';
import JobRequestConfirmation from './react/admin/JobRequest/Confirmation';

import AlertsDashboard from './react/admin/Alerts';

import OnEnterLoadApplicantProfile from './react/OnEnterHooks/loadApplicantProfile';
import OnEnterLoadAdminContacts from './react/OnEnterHooks/loadAdminContacts';
import OnEnterLoadJobRequest from './react/OnEnterHooks/loadJobRequest';
import OnEnterLoadPins from './react/OnEnterHooks/loadPins';
import OnEnterLoadPublicJobRequest from './react/OnEnterHooks/loadPublicJobRequest';
import OnEnterLoadIdentity from './react/OnEnterHooks/loadIdentity';
import OnEnterLoadImpersonation from './react/OnEnterHooks/loadImpersonation';
import OnEnterLoadApplicationData from './react/OnEnterHooks/loadApplicationData';
import OnEnterRedirectUnauthorized, { OnEnterAllowClients, OnEnterAllowEmployees } from './react/OnEnterHooks/redirectUnauthorized';
import combineHooks from './react/OnEnterHooks/combineHooks';

// expanded card view
import ExpandedCard from './react/r_ExpandedCard';

import ReferencesList from './react/admin/ReferencesList';
import TechnologySurvey from './react/admin/TechnologySurvey';

// Contact Dashboard page
import ContactDashboard from './react/admin/Contact/Dashboard';
import ProfilePanel from './react/admin/Contact/Worksheet/Content/Profile';
import ContactExpandedCard from './react/admin/Contact/Dashboard/Card';
import AddContact from './react/admin/Contact/Add';

// Company Dashboard page
import CompanyDashboard from './react/admin/Company/Dashboard';
import CompanyProfilePanel from './react/admin/Company/Worksheet/Content/Profile';
import CompanyJobRequestPanel from './react/admin/Company/Worksheet/Content/JobRequests';
import CompanyContactPanel from './react/admin/Company/Worksheet/Content/Contacts';

// Settings

import SettingsLanding from './react/admin/Settings';
import SettingsUserTab from './react/admin/Settings/User/Landing';
import SettingsEmailsTab from './react/admin/Settings/Emails/Landing';
import SettingsPasswordResetRequestsTab from './react/admin/Settings/PasswordResets/Landing';
import SettingsPushQueueItemsTab from './react/admin/Settings/PushQueueItems/Landing';

// Client components
import ClientLanding, { OnEnterLoadCompanyContacts } from './react/client';
import ClientDashboard from './react/client/ClientDashboard';
import ClientCompanyDashboard from './react/client/CompanyDashboard';
import ClientContactInfo from './react/client/ClientContactInfo';
import ClientCompanyInfo from './react/client/ClientCompanyInfo';
import ClientWelcome from './react/client/ClientWelcome';
import TechQA from './react/client/TechQA';

import JobRequest from './react/client/JobRequest';
import PositionInfo from './react/client/JobRequest/PositionInfo';
import JobRequestDescription from './react/client/JobRequest/JobRequestDescription';
import AddDocuments from './react/client/JobRequest/AddDocuments';

import JobRequestSkills from './react/client/JobRequest/Skills/JobRequestSkills';
import JobRequestSkillSummary from './react/client/JobRequest/Skills/SkillSummary';
import JobRequestAuthorize from './react/client/JobRequest/JobRequestAuthorize';
import WorkSchedule from './react/client/JobRequest/WorkSchedule';
import AdditionalContacts from './react/client/JobRequest/AdditionalContacts';
import JobRequestHistory, {OnEnterLoadJobRequestHistory} from './react/client/JobRequestHistory';

import CreateCompanyContact from './react/client/CreateCompanyContact';

import JobRequestDashboard from './react/admin/JobRequest/Dashboard';

// public components
import PublicLanding from './react/public/PublicLanding';
import ProspectForm from './react/public/PublicProspect';

// Public components
import Login from './react/public/Login';
import ResetPassword from './react/public/ResetPassword';
import ChangePassword from './react/public/ChangePassword';

// function to generate authedRoute handler for 'onEnter'
import authRedirectGen from './utils/authRedirectGen';
import bullhornRedirect from './utils/bullhornRedirect';

// route strings
const loginRoute = 'login';
const adminRoute = 'admin';
const applicantRoute = 'applicant';
const clientRoute = 'client';
const termsRoute = 'terms';
const forgotPasswordRoute = 'forgotpassword';
const publicRoute = 'public';

const unauthedRoutes = [
  '',
  'apply',
  'contactus',
  'job',
  loginRoute,
  termsRoute,
  forgotPasswordRoute,
  publicRoute
];

const authRedirect = authRedirectGen(unauthedRoutes, applicantRoute, adminRoute, clientRoute);

export default store => (
    <Route component={App} onEnter={OnEnterLoadApplicationData(store)}>

      {/* Public routes */}
      <Route path='/' component={PublicLanding}>
        <IndexRoute component={Login} onEnter={combineHooks([OnEnterLoadIdentity(store), authRedirect(store)])} />
        <Redirect from={loginRoute} to='/' />
        <Route path={termsRoute} component={ApplicantTerms} />
        <Route path={forgotPasswordRoute} component={ResetPassword}>
          <Route path='change' component={ChangePassword} />
        </Route>
        <Route path='apply' component={PreliminaryApplication} />
        <Route path='contactus' component={ProspectForm} />
        <Route path='bh/:profileId/:page' onEnter={bullhornRedirect}/>
        <Route path='job/:hash/:jobId' component={JobRequestConfirmation} onEnter={OnEnterLoadPublicJobRequest(store)}/>
      </Route>

      {/* /applicant */}
      <Route path={applicantRoute} onEnter={combineHooks([OnEnterLoadIdentity(store), OnEnterRedirectUnauthorized(store, ['Applicant','Employee']), OnEnterLoadImpersonation(store), OnEnterLoadApplicantProfile(store)])}>
        <IndexRoute component={ApplicantLanding} />
        <Route path={'inactive'} component={ApplicantLanding} />
        <Route path={'resume'} component={ApplicantResume} />
        <Route path={':activeColumnNav'} component={ApplicantDashboard} />
        <Route path={':activeColumnNav/:activeRowSubNav'} component={ApplicantDashboard} />
      </Route>

      {/* /client */}
      <Route path={clientRoute} component={ClientLanding} onEnter={combineHooks([OnEnterLoadIdentity(store), OnEnterAllowClients(store)])}>
        <IndexRoute component={ClientDashboard} onEnter={OnEnterLoadJobRequestHistory(store)}/>
        <Route path='welcome' component={ClientWelcome} />
        <Route path='edit' component={ClientContactInfo} />
        <Route path='company' component={ClientCompanyDashboard} onEnter={OnEnterLoadCompanyContacts(store)} />
        <Route path='company/edit' component={ClientCompanyInfo} />
        <Route path='company/tech' component={TechQA} />
        <Route path='jobrequesthistory' component={JobRequestHistory} onEnter={OnEnterLoadJobRequestHistory(store)}/>
        <Route path='jobrequest/:jobId/confirmation' component={JobRequestConfirmation} onEnter={OnEnterLoadJobRequest(store, true)} />
        <Route path='jobrequest(/:jobId)' component={JobRequest} onEnter={OnEnterLoadJobRequest(store)}>
          <IndexRoute component={PositionInfo} />
          <Route path='description' component={JobRequestDescription} />
          <Route path='adddocuments' component={AddDocuments} />
          <Route path='authorize' component={JobRequestAuthorize} />
          <Route path='skills/summary' component={JobRequestSkillSummary} />
          <Route path='skills(/:categoryId)' component={JobRequestSkills} />
          <Route path='workschedule' component={WorkSchedule} />
          <Route path='addcontact' component={AdditionalContacts} />
        </Route>
        <Route path='newcontact' component={CreateCompanyContact} />
      </Route>

      {/* /admin */}
      <Route path={adminRoute} component={AdminLanding} onEnter={combineHooks([OnEnterLoadIdentity(store), OnEnterAllowEmployees(store), OnEnterLoadPins(store)])}>

        <Route path='settings' component={SettingsLanding} >
          {<Route path='users' component={SettingsUserTab} />}
          {<Route path='emails' component={SettingsEmailsTab} />}
          {<Route path='passwordResetRequests' component={SettingsPasswordResetRequestsTab} />}
          {<Route path='pushQueueItems' component={SettingsPushQueueItemsTab} />}
        </Route>

        {/* /admin/contacts */}
        <Route path='contacts' onEnter={OnEnterLoadAdminContacts(store)}>
          <IndexRoute component={ContactDashboard} />
          <Route path={':contactId'} component={ContactDashboard} >
            <IndexRoute component={ContactExpandedCard} />
          </Route>
          <Route path=':contactId(\\d+)/details' component={ContactWorksheet} onEnter={OnEnterRefreshContact(store)} >
            <IndexRoute component={ProfilePanel} />
            <Route path='company' component={CompanyProfilePanel} />
          </Route>
        </Route>

        {/* /admin/companies */}
        <Route path='companies'>
          <IndexRoute component={CompanyDashboard} />
          <Route path={':companyId/details'} onEnter={OnEnterRefreshCompany(store)} component={CompanyWorksheet} >
            <IndexRoute component={CompanyProfilePanel} />
            <Route path='jobs' component={CompanyJobRequestPanel} />
            <Route path='contacts' component={CompanyContactPanel} />
            <Route path='tech' component={TechQA} />
          </Route>
        </Route>

        {/* /admin/[applicants_status], /admin/prospect, /admin/alerts, /admin/jobrequests, /admin/guide */}
        <IndexRoute component={AdminDashboard} />
        <Route path={'prospect'} component={AddContact}/>
        <Route path={'alerts'} component={AlertsDashboard} />
        <Route path={'jobrequests'} component={JobRequestDashboard} />
        <Route path={'jobrequests/:jobId'} component={JobRequestWorksheet} onEnter={OnEnterLoadJobRequest(store, true)}>
          <IndexRoute component={JobRequestWorksheetProfile} />
        </Route>
        <Route path={'jobrequests/:jobId/confirmation'} component={JobRequestConfirmation} onEnter={OnEnterLoadJobRequest(store, true)} />
        <Route path={'guide'} component={ViewGuide} />
        <Route path={':navColumnState([a-ZA-Z\\s]+)/:profileId(\\d+)/:category/resume'} component={ApplicantResume}/>
        <Route path={':navColumnState([a-ZA-Z\\s]+)/:profileId(\\d+)/:category/:subcategory/resume'} component={ApplicantResume}/>
        <Route path=':navColumnState([a-ZA-Z\\s]+)' component={AdminDashboard}>
          <Route path=':email(\\d+)' component={ExpandedCard}>
            <Route path='references' component={ReferencesList} />
            <Route path='technologysurvey' component={TechnologySurvey} />
          </Route>
          <Route path=':email(\\d+)/:category' component={ExpandedCard} />
          <Route path=':email(\\d+)/:category/:subcategory' component={ExpandedCard} />
        </Route>

      </Route>

      <Redirect from='*' to='/'/> {/* Catch all unmatched routes and redirect to root */}
    </Route>
);



// WEBPACK FOOTER //
// ./shared/routes.js